import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import QRCode from "react-qr-code";
import DownloadIcon from "../../assets/images/images_new/download-button-icon.svg";
import CheckIcon from "../../assets/images/images_new/check-circle.svg";
import AppleIcon from "../../assets/images/images_new/apple-icon.svg";
import PlayStoreIcon from "../../assets/images/images_new/play-store-icon.svg";

const AppDownloadPopup = ({ showDownloadModal: externalShow, setShowDownloadModal: externalSet}) => {
     const [internalShow, setInternalShow] = useState(false);
    const showDownloadModal = externalShow !== undefined ? externalShow : internalShow;
    const setShowDownloadModal = externalSet !== undefined ? externalSet : setInternalShow;

    // Detect if we are on a NAATI page to show the correct app links
    const isNaatiPage = window.location.pathname.toLowerCase().includes('naati');
    
    // Choose the correct URLs based on the app type
    const fallbacks = {
        pte: {
            ios: 'https://apps.apple.com/in/app/la-pte/id6443614190',
            android: 'https://play.google.com/store/search?q=language+academy&c=apps&hl=en_IN'
        },
        naati: {
            ios: 'https://apps.apple.com/au/app/la-ccl/id1536541464',
            android: 'https://play.google.com/store/apps/details?id=com.languageacademy.naati'
        }
    };

    const getSafeEnv = (key) => {
        const val = import.meta.env[key];
        return (val && val !== "undefined" && val !== "null") ? val : null;
    };

    const iosUrl = (isNaatiPage ? getSafeEnv('VITE_NAATI_IOS_APP_URL') : getSafeEnv('VITE_PTE_IOS_APP_URL')) || (isNaatiPage ? fallbacks.naati.ios : fallbacks.pte.ios);
    const androidUrl = (isNaatiPage ? getSafeEnv('VITE_NAATI_ANDROID_APP_URL') : getSafeEnv('VITE_PTE_ANDROID_APP_URL')) || (isNaatiPage ? fallbacks.naati.android : fallbacks.pte.android);
    const appType = isNaatiPage ? 'naati' : 'pte';

    // The QR code points to our smart redirect with the app type as a parameter
    const downloadUrl = `${window.location.origin}/download-app?app=${appType}`;

    const features = [
        { icon: "📊", text: "Progress Tracking – Sync across all devices" },
        { icon: "🔔", text: "Push Notifications – Never miss practice" },
        { icon: "🔄", text: "Cross-Device Sync – Continue where you left" }
    ];

    return (
        <>
            <style>{`
                .app-download-modal-content {
                    border-radius: 24px !important;
                    overflow: hidden !important;
                }
            `}</style>
            {/* Floating Download Button */}
            <div
                className="floating-download-btn"
                onClick={() => setShowDownloadModal(true)}
                title="Download App"
            >
                <img src={DownloadIcon} alt="Download" />
            </div>

            {/* Custom Download Modal */}
            <Modal
                show={showDownloadModal}
                onHide={() => setShowDownloadModal(false)}
                centered
                dialogClassName="app-download-modal-dialog"
                contentClassName="app-download-modal-content"
            >
                <div className="app-download-modal-body">
                    <button className="close-modal-btn" onClick={() => setShowDownloadModal(false)}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                    </button>

                    <div className="modal-header-custom text-center">
                        <div className="download-icon-wrapper">
                            <img src={DownloadIcon} alt="Download" />
                        </div>
                        <h2 className="modal-title-custom">Download Our App</h2>
                        <p className="modal-subtitle-custom">Practice anytime, anywhere with our mobile app</p>
                    </div>

                    <div className="modal-divider"></div>

                    <ul className="modal-feature-list">
                        {features.map((feature, index) => (
                            <li key={index} className="feature-item">
                                <img src={CheckIcon} className="check-icon" alt="check" />
                                <span className="feature-icon">{feature.icon}</span>
                                <span className="feature-text">{feature.text}</span>
                            </li>
                        ))}
                    </ul>

                    <div className="modal-bottom-section">
                        <div className="qr-code-wrapper">
                            <div className="qr-code-container">
                                <QRCode value={downloadUrl} size={110} />
                            </div>
                        </div>
                        <div className="store-buttons-wrapper">
                            <a href={iosUrl} target="_blank" rel="noopener noreferrer" className="store-button">
                                <img src={AppleIcon} alt="App Store" />
                                <div className="button-text">
                                    <span className="small-text">Download on</span>
                                    <span className="large-text">App Store</span>
                                </div>
                            </a>
                            <a href={androidUrl} target="_blank" rel="noopener noreferrer" className="store-button">
                                <img src={PlayStoreIcon} alt="Play Store" />
                                <div className="button-text">
                                    <span className="small-text">Get it on</span>
                                    <span className="large-text">Play Store</span>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default AppDownloadPopup;
